import { ApiRequest, postItem, patchItem, deleteItem } from "utils/ApiUtils";
import { Document } from 'classes';
import ODataUtil from './ODataUtil';


const documents_endpoint = "/ProjectDocument";

async function getProjectDocuments(page, per_page, orderByInfo, orderByDirection, search, filters) {
  const data = await ODataUtil.gridQuery(page, per_page, orderByInfo, orderByDirection, search, filters, { model: Document, endpoint: documents_endpoint });
  return data;
}


async function addDocument(data) {
  const resourcePath = `${documents_endpoint}/Upload`;
  const params = `?ProjectId=${data.ProjectId}&DocFileDestinationId=${data.DocFileDestinationId}&Description=${data.Description}`;
  const result = await postItem(resourcePath, params, { value: data.value });
  // console.log(result)
  return result;
};

async function updateDocument(data) {
  const resourcePath = `${documents_endpoint}/Update`;
  const params = `?docid=${data.ProjDocId}`;
  const result = await patchItem(resourcePath, params, data)
  // console.log(result)
  return result;
};

async function downloadDocument(data) {
  const resourcePath = `${documents_endpoint}/Url`;
  const params = `?fileName=${data.FileName}`;
  const result = await ApiRequest(resourcePath, params);
  console.log(result)
  return result;
};

async function deleteDocument(projectId, data) {
  const resourcePath = `${documents_endpoint}/`;
  const params = `?id=${data.ProjDocId}`;
  const result = await deleteItem(resourcePath, params);
  return result;
};

const getDocFileTypeDomains = async () => {
  const fileTypes = await ApiRequest('/Domain?domainName=LuDocFileDestination&includeReserved=false');
  return fileTypes.data;
}

export { Document, getProjectDocuments, addDocument, updateDocument, deleteDocument, getDocFileTypeDomains,downloadDocument };